import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.png';
import auth from '../../assets/images/authentication/img-auth-sideimg.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postData } from '../Services/api';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    useEffect(() => {
        if (token) {
            navigate('/');
        }
    }, []);

    const toggleVisibility = () => {
        setShowPassword(!showPassword);
    };

    const initialValues = {
        email: '',
        company_name: '',
        password: ''
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        company_name: Yup.string()
            .required('Company Name is required'),
        password: Yup.string()
            .required('Password is required')
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
        const res = await postData('/auth/admin-login', values);

        // ✅ Success check
        if (res?.status === true && res?.data?.token) {
            localStorage.setItem("token", res.data.token);

            toast.success(res.message || "Login successful");

            resetForm();
            const userRole = res.data.user?.role;
            if (userRole === 'accounts') {
                navigate('/accounts-dashboard/view-edit');
            } else {
                navigate('/');
            }
        } 
        else {
            toast.error(res?.message || "Login failed");
        }

    } catch (error) {
        console.log("Login Error:", error);

        // ✅ Backend error message safe access
        const msg =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Server error. Try again.";

        toast.error(msg);
    } 
    finally {
        setSubmitting(false);
    }
};


    return (
        <div className="auth-main">
            <div className="auth-wrapper v2">
                <div className="auth-sidecontent">
                    <img src={auth} alt="images" className="img-fluid img-auth-side" />
                </div>
                <div className="auth-form">
                    <div className="card my-5">
                        <div className="card-body">
                            <div className="text-center mb-5">
                                <Link to="#">
                                    <img src={logo} width={100} height={100} alt="img" />
                                </Link>
                            </div>
                            <h4 className="text-center f-w-500 mb-3">Login with your email</h4>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        <div className="form-group mb-3">
                                            <Field
                                                type="text"
                                                name="company_name"
                                                className="form-control"
                                                placeholder="Company Name"
                                            />
                                            <ErrorMessage
                                                name="company_name"
                                                component="div"
                                                className="text-danger fs-12 mt-1"
                                            />
                                        </div>
                                        <div className="form-group mb-3">
                                            <Field
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                placeholder="Email Address"
                                            />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger fs-12 mt-1"
                                            />
                                        </div>

                                        <div className="input-group">
                                            <Field
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                className="form-control"
                                                placeholder="*******"
                                            />
                                            <span
                                                className="input-group-text"
                                                onClick={toggleVisibility}
                                                style={{ cursor: 'pointer' }}
                                                id="validationTooltipUsernamePrepend"
                                            >
                                                <i className={`fa ${!showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </span>
                                        </div>
                                        <ErrorMessage
                                            name="password"
                                            component="div"
                                            className="text-danger fs-12 mt-1"
                                        />

                                        <div className="d-grid mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    "Sign In"
                                                )}
                                            </button>
                                        </div>
                                        <p className="text-center mt-3">
                                        Register New account? <Link to="/register">Register</Link>
                                        </p>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
